<template>
  <div @mouseup="fireUniversalEventMouseUp" id="app" ref="appcomp" class="">
    <Sidebar v-if="notSpecialRoute" />
    <Navbar v-if="notSpecialRoute" />
    <div
      :class="{
        'squeeze-for-sidebar': sidebarToggleStatus,
        'expand-for-sidebar': !sidebarToggleStatus,
      }"
      class="main__container"
    >
      <keep-alive>
        <router-view class="#content"></router-view>
      </keep-alive>
      <BottomDock v-if="notSpecialRoute" />
      <Camera />
    </div>
    <!-- div for single chat message -->
    <!-- Message to the right -->
    <transition name="fade">
      <NotificationBox :msg="message" v-if="isNewNotification" />
    </transition>
    <ed-tooltip />
  </div>
</template>

<script>
// import io from 'socket.io-client';
import hotkeys from 'hotkeys-js';
import { mapGetters } from 'vuex';
import graphShortcut from '@/utils/graphShortcut';
import hotKeyMappings from '@/utils/hotKeyMappings';
import NotificationBox from '@/components/NotificationBox.vue';
import Navbar from '@/components/Navbar.vue';
import Sidebar from '@/components/Sidebar.vue';
import BottomDock from '@/components/BottomDock.vue';
import Camera from '@/components/Camera.vue';
import universalMappings from '@/utils/universalMapping';
import 'boxicons';
import 'mavon-editor/dist/css/index.css';
import exploreOps from '@/utils/exploreOps';
import smartQueryMode from '@/utils/smartQueryMode';
import edTooltip from '@/utilities/ed-tooltip.vue';

export default {
  name: 'app',

  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: 'Thoughtjumper',
    // all titles will be injected into this template
    titleTemplate: '%s | Thoughtjumper',
  },

  components: {
    Navbar,
    NotificationBox,
    Sidebar,
    BottomDock,
    Camera,
    edTooltip,
  },

  data() {
    return {
      specialRoute: ['Auth', 'embed'],
      isNewNotification: false,
      message: 'sasds',
      hotKeyMappings,
    };
  },

  computed: {
    ...mapGetters({
      user: 'auth/authUser',
    }),
    sidebarToggleStatus() {
      return this.$store.state.uiStates.sidebarToggleStatus;
    },

    getCameraStatus() {
      return this.$store.state.cameraStatus;
    },
    username() {
      return this.user.username;
    },

    notSpecialRoute() {
      return !this.specialRoute.includes(this.$store.state.routeInfo);
    },
  },

  mounted() {
    console.log('FrameBed APp.vue', this.$store.state.routeInfo);
    this.$refs.appcomp.addEventListener('runCode', (e) => {
      const globalOperations = smartQueryMode(e.detail.trim());

      if (globalOperations.createList !== undefined) {
        console.log('createList', globalOperations.createList);
        exploreOps.queryOperation(globalOperations.createList);
      }
    });

    this.$refs.appcomp.addEventListener('runNode', (e) => {
      console.log('runNode', e.detail);
      this.$store.dispatch('focusCurrentItem', {
        id: e.detail.id,
        type: 'node',
        state: {
          isActiveDetail: 'Nodes', //! Its not a good way but doing it just to make it work
        },
      });
    });
    graphShortcut();
    this.hotKeyFunctionGenerator(hotKeyMappings);
    hotkeys('alt+shift+r', () => this.hotkeyPressedstartScreenRecord());
    hotkeys('shift+e', () => this.hotKeyPressedSwitchRoute('/'));
    hotkeys('alt+shift+1', () => this.chooseMode('node_operation'));
    hotkeys('shift+a', () => this.hotKeyPressedSwitchRoute('/Author-view'));
    hotkeys('shift+s', () => this.hotKeyPressedSwitchRoute('/Simplified-view'));
    hotkeys('shift+r', () => this.hotKeyPressedSwitchRoute('/Reading-view'));
    hotkeys('shift+c', () => this.hotKeyPressedSwitchRoute('/canvas'));
    universalMappings.forEach((mapping) => {
      hotkeys(mapping.hotKey, () => this.chooseMode(mapping.mode_name));
    });
    if (this.notSpecialRoute) {
      this.addZohoChatbot();
    }
  },

  methods: {
    addZohoChatbot() {
      setTimeout(() => {
        const newScript = document.createElement('script');
        newScript.setAttribute('type', 'text/javascript');
        newScript.id = 'zsiqchat';
        const alert = document.createTextNode(
          // eslint-disable-next-line
          'var $zoho = $zoho || {}; $zoho.salesiq = $zoho.salesiq || { widgetcode: "dc0ff82261947de37479c2b1838a2a7fa254e881085b0fcad83c3ce09612048af7c305c2a31f970cf47811fbbca424f3", values: {}, ready: function () { } }; var d = document; s = d.createElement("script"); s.type = "text/javascript"; s.id = "zsiqscript"; s.defer = true; s.src = "https://salesiq.zoho.in/widget"; t = d.getElementsByTagName("script")[0]; t.parentNode.insertBefore(s, t);',
        );
        newScript.appendChild(alert);
        document.body.appendChild(newScript);
      }, 2000);
    },
    chooseMode(modename) {
      console.log(modename, 'FIrrrrrrrrrrrrrrrrrrrrrrrrrr');
      this.$store.dispatch('chooseMode', modename);
    },
    activeLayoutPayload(componentName) {
      const payload = {
        layoutKey: this.$store.state.activeLayoutKey,
        componentName,
      };
      return payload;
    },
    hotKeyFunctionGenerator(mapping) {
      mapping.forEach((keyMap) => {
        hotkeys(keyMap.key, () => this.hotKeyPressedSwitchComponent(keyMap.mapping));
      });
    },
    hotKeyPressedSwitchComponent(componentName) {
      this.$store.dispatch(
        'activateLayout',
        this.activeLayoutPayload(componentName.trim()),
      );
    },
    hotKeyPressedSwitchRoute(route) {
      this.$router.push({ path: route });
    },
    hotkeyPressedstartScreenRecord() {
      this.$root.$emit('startScreenRecord');
    },
    countWords(str) {
      let strWord = str.replace(/(^\s*)|(\s*$)/gi, '');
      strWord = strWord.replace(/[ ]{2,}/gi, ' ');
      strWord = strWord.replace(/\n /, '\n');
      return strWord.split(' ').length;
    },

    async fireUniversalEventMouseUp(e) {
      console.log('fireUniversalEventMouseUp', e);
      if (e.ctrlKey || e.metaKey) {
        const select = window.getSelection().toString();
        // Regex to calculate the Word Cound
        console.log(this.countWords(select));
        const wordCount = this.countWords(select);
        console.log(typeof select);
        if (wordCount <= 4 && wordCount > 0) {
          if (wordCount === 1) {
            const oneSearch = select.replace(/\s/g, '');
            if (oneSearch.length > 1) {
              console.log(oneSearch.length);
              console.log({ oneSearch });
              const wordObj = {
                word: oneSearch,
                label: oneSearch,
                type: 'string',
                lang: 'en',
              };
              // this.$store.commit('SET_CURRENT_ENTITY', wordObj);
              await this.$store.dispatch('setCurrentThought', wordObj);
              this.showModal = true;
            }
          } else {
            const wordObj = {
              word: select,
              label: select,
              type: 'string',
              lang: 'en',
            };
            // this.$store.commit('SET_CURRENT_ENTITY', wordObj);
            this.$store.dispatch('setCurrentThought', wordObj);
          }
          // console.log("wordC",wordCount)
        }
      } else if (e.altKey || e.metaKey) {
        const select = window.getSelection().toString();
        const oneSearch = select.replace(/\s/g, '');
        const url = await this.$store.dispatch('dictWordPopUp', oneSearch);
        console.log('testing', url.result[0].word);
        const title = url.result[0].word;
        const info = url.result[0].meanings[0].definitions[0].definition;
        this.edvantaPopup(title, info);
      }
    },
    fireUniversalEvent() {
      if (this.$store.state.edit_mode !== 'node_operation') {
        const select = window.getSelection().toString();
        // Regex to calculate the Word Cound
        console.log(this.countWords(select));
        const wordCount = this.countWords(select);
        console.log(typeof select);
        if (wordCount <= 4 && wordCount > 0) {
          if (wordCount === 1) {
            const oneSearch = select.replace(/\s/g, '');
            if (oneSearch.length > 1) {
              console.log(oneSearch.length);
              console.log({ oneSearch });
              const wordObj = {
                word: oneSearch,
                label: oneSearch,
                type: 'string',
                lang: 'en',
              };
              // this.$store.commit('SET_CURRENT_ENTITY', wordObj);
              this.$store.dispatch('setCurrentThought', wordObj);
            }
          } else {
            const wordObj = {
              word: select,
              label: select,
              type: 'string',
              lang: 'en',
            };
            // this.$store.commit('SET_CURRENT_ENTITY', wordObj);
            this.$store.dispatch('setCurrentThought', wordObj);
          }

          // console.log("wordC",wordCount)
        }
      }
    },
    resetTip(selector) {
      /*
        fn() => resetTip

        desc
          get selector and remove all the classes that are added there

        returns
          null
      */
      const popup = document.querySelector(selector);
      if (popup.children[0].classList.contains('ed-popup__tip--top')) {
        popup.children[0].classList.remove('ed-popup__tip--top');
      }
      if (popup.children[0].classList.contains('ed-popup__tip--left')) {
        popup.children[0].classList.remove('ed-popup__tip--left');
      }
      if (popup.children[0].classList.contains('ed-popup__tip--right')) {
        popup.children[0].classList.remove('ed-popup__tip--right');
      }
      if (popup.children[0].classList.contains('ed-popup__tip--bottom')) {
        popup.children[0].classList.remove('ed-popup__tip--bottom');
      }
    },
    getClasses(direction, initClass) {
      const classList = [];

      /*
        fn() => getClasses

        desc
          return classes for as per the direction

        returns
          classList: list of classes used in popup
      */
      if (direction === 'bottom-left') {
        classList.push(`${initClass}__tip--top`);
        classList.push(`${initClass}__tip--left`);
      } else if (direction === 'bottom-right') {
        classList.push(`${initClass}__tip--top`);
        classList.push(`${initClass}__tip--right`);
      } else if (direction === 'top-left') {
        classList.push(`${initClass}__tip--bottom`);
        classList.push(`${initClass}__tip--left`);
      } else {
        classList.push(`${initClass}__tip--bottom`);
        classList.push(`${initClass}__tip--right`);
      }
      return classList;
    },
    getPositions(top, left, popupWidth, popupHeight) {
      const position = {};
      if (top < popupHeight) {
        if (document.body.clientWidth - left > popupWidth) {
          // popup: bottom-left
          // tip: top left
          position.direction = 'bottom-left';
          position.x = left;
          position.y = top + 30;
        } else {
          // popup: bottom-right
          // tip: top-right
          position.direction = 'bottom-right';
          position.x = left - (popupWidth * 90) / 100;
          position.y = top + 30;
        }
      } else {
        // popup: top-left
        // tip: bottom-right
        // eslint-disable-next-line no-lonely-if
        if (document.body.clientWidth - left > popupWidth) {
          position.direction = 'top-left';
          position.x = left;
          position.y = top - popupHeight - 20;
        } else {
          position.direction = 'top-right';
          position.x = left - (popupWidth * 90) / 100;
          position.y = top - popupHeight - 20;
        }
      }
      return position;
    },
    edvantaPopup(title, info) {
      const selection = document.getSelection();
      console.log(selection.toString());
      const oRange = selection.getRangeAt(0); // get the text range
      const oRect = oRange.getBoundingClientRect();
      console.log(oRect);
      const popup = document.querySelector('.ed-popup');
      console.log('MYPOPUP', popup);
      popup.children[1].children[0].innerHTML = title;
      popup.children[1].children[1].innerHTML = info;
      popup.style.display = 'block';
      const position = this.getPositions(
        oRect.top,
        oRect.left,
        popup.clientWidth,
        popup.clientHeight,
      );
      console.log('MYPOPUP', position);
      popup.style.top = `${position.y}px`;
      popup.style.left = `${position.x}px`;
      this.resetTip('.ed-popup');
      this.getClasses(position.direction, 'ed-popup').forEach((eachClass) => {
        popup.children[0].classList.add(eachClass);
      });
    },
  },

  sockets: {
    connect() {
      console.log('socket connected');
    },
    newNotification(message) {
      if (this.user !== null) {
        const msg = JSON.parse(message);
        // console.log(message);
        if (msg.verb.display.en) {
          // this.$store.dispatch('eventsDumpFetch');
          if (msg.verb.display.en === 'VISITED') {
            this.isNewNotification = !this.isNewNotification;
            console.log(msg, 'from VISITED');
            this.message = `${msg.actor.username} ${msg.verb.display.en} <a style="color:red" href="${msg.value.url}">${msg.value.title}</a>`;
            setTimeout(() => {
              this.isNewNotification = !this.isNewNotification;
            }, 4000);
          }
          if (msg.verb.display.en === 'NOTED') {
            console.log(msg, 'from NOTED');
          }
          if (msg.verb.display.en === 'SEARCHED_PING') {
            console.log(msg, 'from SEARCHED_PING');
            console.log(msg.actor.username, this.$store.state.auth.user.username);
            if (this.$store.state.auth.user.username === msg.actor.username) {
              const wordObj = {
                word: msg.value.word,
                label: msg.value.word,
                type: 'string',
                lang: 'en',
              };
              // this.$store.commit('SET_CURRENT_ENTITY', wordObj);
              this.$store.dispatch('setCurrentThought', wordObj);
            }
          }
        }
      }
    },
  },
  // set the persisted locale
  async created() {
    // ! TODO - needs to refactor
    await this.$highway.singleDispatcher('gmodule/exploreGraphFetch');

    const systemLocale = localStorage.getItem('locale');
    if (systemLocale) {
      this.$store.dispatch('changeLocale', systemLocale);
      this.$i18n.locale = systemLocale;
    } else if (navigator.language) {
      // fetch the preferred language for the user if not in local stroage
      const language = navigator.language.substring(0, 2);
      this.$store.dispatch('changeLocale', language);
      this.$i18n.locale = language;
    }
  },
};
</script>

<style lang="scss">
@import "./scss/app.scss";
@import "~ag-grid-community/dist/styles/ag-grid.css";
@import "~ag-grid-community/dist/styles/ag-theme-alpine.css";
</style>
